import Commerce from "types/models/Commerce";
import Venue from "types/models/Venue";

export default interface CustomSelectProps {
    items: Commerce[] | Venue[];
    callback: (...args: any[]) => any;
    isCommerceEditor: boolean;
    identifierType?: IdentifierType;
    entityType?: EntityType;
    idOrCodesToPickFirst?: string;
}

export enum IdentifierType {
    Code = 'code',
    Id = 'id',
}

export enum EntityType {
    Commerce = 'commerce',
    Venue = 'venue',
}